/* ==========================================================================
   GutNourish theme — product-form.js
   Subscription-aware buy box.

   Reads a JSON payload rendered by sections/main-product.liquid describing every
   variant and its selling-plan allocations. Works with ANY Shopify subscription
   app (Loop, Recharge, etc.) because they all publish native SellingPlanGroups.

   If no selling plans exist yet — e.g. before the subscription app is installed —
   the purchase-type control hides itself and this degrades to a plain variant
   picker. The page is never broken by a missing app.
   ========================================================================== */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* Subscription apps name their plans however they like — Loop tends to emit
     things like "Delivery every 1 month". We print the name inside a sentence
     ("$164.95 billed every 3 months"), so normalise it rather than trusting it. */
  function cadencePhrase(name) {
    if (!name) return '';
    var s = String(name).toLowerCase().trim();
    s = s.replace(/^(delivery|deliver|subscription|subscribe|ships?)\s+/, '');
    s = s.replace(/^(once\s+)?every\s+1\s+/, 'every ');
    s = s.replace(/\s+/g, ' ').trim();
    if (s && !/^every\b/.test(s) && /^\d/.test(s)) s = 'every ' + s;
    return s;
  }

  function initProductForm(root) {
    $$('[data-product-form]', root === document ? document : root.parentNode || document).forEach(setup);
    if (root !== document && root.matches && root.matches('[data-product-form]')) setup(root);
  }

  function setup(form) {
    if (form.dataset.wired === 'true') return;
    form.dataset.wired = 'true';

    var dataEl = $('[data-product-json]', form);
    if (!dataEl) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var variants = data.variants || [];
    if (!variants.length) return;

    var hasPlans = variants.some(function (v) { return (v.sellingPlans || []).length; });

    var state = {
      variantId: data.initialVariantId || variants[0].id,
      mode: hasPlans && data.defaultSubscribe ? 'subscribe' : 'onetime',
      planId: null
    };

    var els = {
      seg: $('[data-purchase-type]', form),
      segSave: $('[data-seg-save]', form),
      segBtns: $$('[data-mode]', form),
      rows: $$('[data-variant-row]', form),
      freqWrap: $('[data-frequency]', form),
      freqSelect: $('[data-frequency-select]', form),
      unit: $('[data-price-unit]', form),
      unitLabel: $('[data-price-unit-label]', form),
      compare: $('[data-price-compare]', form),
      cadence: $('[data-price-cadence]', form),
      save: $('[data-price-save]', form),
      submit: $('[data-atc]', form),
      note: $('[data-atc-note]', form),
      idInput: $('[name="id"]', form),
      planInput: $('[name="selling_plan"]', form),
      stickyWhat: $('[data-sticky-what]'),
      stickyPrice: $('[data-sticky-price]')
    };

    if (els.seg) els.seg.hidden = !hasPlans;

    function variant(id) {
      for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
      return variants[0];
    }

    function plansFor(v) { return v.sellingPlans || []; }

    /* Subscription apps list frequencies in whatever order they were created, so
       "first plan" is not a sensible default — it currently means every 2 weeks on
       a one-month tub. Default instead to the cadence that matches how long the
       pack actually lasts: 1 tub (1 month supply) -> monthly, 3 tubs -> quarterly.
       Derived from the data, so it stays right if frequencies are added later. */
    function cadenceDays(name) {
      var m = String(name || '').toLowerCase().match(/(\d+)?\s*(day|week|month|year)/);
      if (!m) return null;
      var n = parseInt(m[1] || '1', 10);
      var unit = m[2];
      return n * (unit === 'day' ? 1 : unit === 'week' ? 7 : unit === 'month' ? 30 : 365);
    }

    function defaultPlanId(v) {
      var plans = plansFor(v);
      if (!plans.length) return null;
      var wantDays = (v.tubs || 1) * 30;
      var best = plans[0], bestDelta = Infinity;
      plans.forEach(function (p) {
        var c = cadenceDays(p.name);
        if (c === null) return;
        var d = Math.abs(c - wantDays);
        if (d < bestDelta) { bestDelta = d; best = p; }
      });
      return best.id;
    }


    function currentOffer() {
      var v = variant(state.variantId);
      if (state.mode === 'subscribe') {
        var plans = plansFor(v);
        var defId = defaultPlanId(v);
        var plan = plans.filter(function (p) { return p.id === state.planId; })[0]
                || plans.filter(function (p) { return p.id === defId; })[0] || plans[0];
        if (plan) {
          return {
            price: plan.price,
            compareAt: plan.compareAtPrice || v.compareAtPrice,
            cadence: plan.name,
            plan: plan,
            subscribing: true,
            variant: v
          };
        }
      }
      return { price: v.price, compareAt: v.compareAtPrice, cadence: null, plan: null, subscribing: false, variant: v };
    }

    function money(cents) { return window.formatMoney ? window.formatMoney(cents) : '$' + (cents / 100).toFixed(2); }

    function paintRows() {
      els.rows.forEach(function (row) {
        var id = parseInt(row.getAttribute('data-variant-row'), 10);
        var v = variant(id);
        var subscribable = state.mode !== 'subscribe' || plansFor(v).length > 0;
        var usable = v.available && subscribable;

        // A size with no subscription plan is hidden outright while Subscribe is
        // active, rather than shown greyed out — no dead option in the list.
        row.hidden = state.mode === 'subscribe' && plansFor(v).length === 0;

        row.classList.toggle('supply__row--off', !usable && !row.hidden);
        row.classList.toggle('supply__row--on', usable && id === state.variantId);

        var input = $('input', row);
        if (input) { input.disabled = !usable; input.checked = usable && id === state.variantId; }

        var offer = null;
        if (state.mode === 'subscribe' && plansFor(v).length) {
          var defId2 = defaultPlanId(v);
          var p = plansFor(v).filter(function (x) { return x.id === defId2; })[0] || plansFor(v)[0];
          offer = { price: p.price, per: true };
        } else {
          offer = { price: v.price, per: false };
        }

        var unitEl = $('[data-row-unit]', row);
        var totalEl = $('[data-row-total]', row);
        if (unitEl) unitEl.textContent = v.tubs ? money(Math.round(offer.price / v.tubs)) : money(offer.price);
        if (totalEl) {
          totalEl.textContent = money(offer.price) + (offer.per ? ' / ' + (row.getAttribute('data-per-label') || 'delivery') : '');
        }

        var metaEl = $('[data-row-meta]', row);
        if (metaEl && metaEl.getAttribute('data-default-meta')) {
          metaEl.textContent = (state.mode === 'subscribe' && !plansFor(v).length)
            ? (metaEl.getAttribute('data-unavailable-meta') || 'Not available on subscription')
            : metaEl.getAttribute('data-default-meta');
        }
      });
    }

    function paintFrequency() {
      if (!els.freqWrap || !els.freqSelect) return;
      var v = variant(state.variantId);
      var plans = plansFor(v);
      var show = state.mode === 'subscribe' && plans.length > 0;
      els.freqWrap.hidden = !show;
      if (!show) return;

      if (!plans.some(function (p) { return p.id === state.planId; })) state.planId = defaultPlanId(v);

      els.freqSelect.innerHTML = plans.map(function (p) {
        return '<option value="' + p.id + '"' + (p.id === state.planId ? ' selected' : '') + '>' + p.name + '</option>';
      }).join('');
      els.freqSelect.disabled = plans.length < 2;
    }

    function paintPrice() {
      var o = currentOffer();
      var v = o.variant;
      var perTub = v.tubs ? Math.round(o.price / v.tubs) : o.price;

      if (els.unit) els.unit.textContent = money(perTub);
      if (els.unitLabel) els.unitLabel.hidden = !v.tubs;
      if (els.compare) {
        var rrp = v.rrpPerTub || o.compareAt;
        els.compare.textContent = rrp ? money(rrp) : '';
        els.compare.hidden = !rrp || rrp <= perTub;
      }
      if (els.cadence) {
        els.cadence.innerHTML = o.subscribing
          ? '<b>' + money(o.price) + '</b> ' + (data.strings.billed || 'billed') + ' ' + cadencePhrase(o.cadence)
          : '<b>' + money(o.price) + '</b> ' + (data.strings.oneTime || 'one-time purchase');
      }
      if (els.save) {
        var saving = 0;
        if (o.subscribing) saving = v.price - o.price;            // vs one-time, same size
        else if (v.compareAtPrice) saving = v.compareAtPrice - v.price;
        els.save.hidden = saving <= 0;
        els.save.textContent = (data.strings.save || 'Save') + ' ' + money(saving) + (o.subscribing ? ' ' + (data.strings.perDelivery || 'per delivery') : '');
      }

      if (els.submit) {
        els.submit.disabled = !v.available;
        els.submit.textContent = v.available
          ? (data.strings.addToCart || 'Add to cart') + ' — ' + money(o.price)
          : (data.strings.soldOut || 'Sold out');
      }
      if (els.note) {
        els.note.textContent = o.subscribing
          ? (data.strings.noteSubscribe || '')
          : (v.freeShipping ? (data.strings.noteFree || '') : (data.strings.noteShipping || ''));
      }

      if (els.idInput) els.idInput.value = v.id;
      if (els.planInput) { els.planInput.value = o.plan ? o.plan.id : ''; els.planInput.disabled = !o.plan; }

      if (els.stickyWhat) els.stickyWhat.textContent = data.productTitle + ' · ' + v.title;
      if (els.stickyPrice) {
        els.stickyPrice.textContent = money(o.price) + (o.subscribing ? ' ' + cadencePhrase(o.cadence) : '');
      }

      form.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: v, offer: o } }));
    }

    function paintMode() {
      els.segBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-mode') === state.mode));
      });

      /* Put the actual saving on the Subscribe control itself. It's the reason to
         press it, and it changes per size — reading it off the live plan keeps it
         honest if Loop's pricing ever moves. */
      if (els.segSave) {
        var v = variant(state.variantId);
        var plans = plansFor(v);
        var pct = 0;
        if (plans.length && v.price > 0) {
          /* Quote the saving on the plan the shopper will actually get, not the
             cheapest one in the group. Advertising the best price in the list
             over-promises whenever a longer cadence carries a bigger discount. */
          var shown = plans.filter(function (p) { return p.id === state.planId; })[0]
                   || plans.filter(function (p) { return p.id === defaultPlanId(v); })[0]
                   || plans[0];
          pct = Math.round((1 - shown.price / v.price) * 100);
        }
        els.segSave.hidden = pct <= 0;
        els.segSave.textContent = (data.strings.saveShort || 'Save') + ' ' + pct + '%';
      }
    }

    function render() { paintMode(); paintRows(); paintFrequency(); paintPrice(); }

    els.segBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.mode = btn.getAttribute('data-mode');
        // If the current size has no plan, fall back to one that does — preferring
        // the configured default size over simply the first (cheapest) one.
        if (state.mode === 'subscribe' && !plansFor(variant(state.variantId)).length) {
          var subscribable = variants.filter(function (v) { return plansFor(v).length && v.available; });
          var preferred = subscribable.filter(function (v) { return v.id === data.initialVariantId; })[0];
          var fallback = preferred || subscribable[0];
          if (fallback) state.variantId = fallback.id;
        }
        render();
      });
    });

    els.rows.forEach(function (row) {
      row.addEventListener('click', function (e) {
        var id = parseInt(row.getAttribute('data-variant-row'), 10);
        var v = variant(id);
        if (!v.available || (state.mode === 'subscribe' && !plansFor(v).length)) { e.preventDefault(); return; }
        state.variantId = id;
        render();
      });
    });

    if (els.freqSelect) {
      els.freqSelect.addEventListener('change', function () {
        state.planId = parseInt(els.freqSelect.value, 10);
        /* the saving chip is derived from the chosen plan, so it has to repaint
           with the price — not just the price line */
        paintMode();
        paintPrice();
      });
    }

    form.addEventListener('submit', function (e) {
      if (!window.addToCart) return;               // no JS cart: let the form post normally
      e.preventDefault();
      var o = currentOffer();
      var payload = { items: [{ id: o.variant.id, quantity: 1 }] };
      if (o.plan) payload.items[0].selling_plan = o.plan.id;
      els.submit.disabled = true;
      var label = els.submit.textContent;
      window.addToCart(payload, els.submit)
        .then(function () { els.submit.textContent = data.strings.added || 'Added'; })
        .catch(function () {})
        .then(function () {
          setTimeout(function () { els.submit.disabled = false; paintPrice(); }, 1200);
        });
    });

    $$('[data-sticky-bar] [data-atc-proxy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    });

    render();
  }

  window.initProductForm = initProductForm;
  if (document.readyState !== 'loading') initProductForm(document);
  else document.addEventListener('DOMContentLoaded', function () { initProductForm(document); });
})();
